export const isElementVisible = (element: HTMLElement) => {
  return window.getComputedStyle(element).display !== 'none';
};
